<template>
    <div class="income-flow">
        <div class="select-item flex">
            <el-select v-model="form.storeId" :placeholder="$t('Common.all_store2')">
                <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="form.salesStaffId" :placeholder="$t('Sell.saler')">
                <input
                    class="search-input-all"
                    type="text"
                    v-model="searchText" >
                <el-option
                    v-for="item in filterList"
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id"
                    :disabled="item.id === 'no'">
                </el-option>
            </el-select>
            <el-select v-model="form.contractType" :placeholder="$t('Contract.all_type')">
                <el-option
                    v-for="item in options"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
            </el-select>
            <el-select v-model="form.operationType" :placeholder="$t('Contract.operation_types')">
                <el-option
                    v-for="item in operations"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
            </el-select>
            <el-select v-model="form.payMethod" :placeholder="$t('Sell.pay_methods')">
                <el-option
                    v-for="item in pays"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
            </el-select>
            <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('Common.start_time')"
                :end-placeholder="$t('Common.end_time')">
            </el-date-picker>
            <el-button
                type="primary"
                @click="fetchData(1)"
            > {{ $t('Common.search_cha') }} </el-button>
            <el-button @click="handleReset()"> {{ $t('Common.clear') }} </el-button>
        </div>
        <div class="time-tip" flow-left>
            {{ $t('Week.refresh_time') }}
        </div>

        <el-table
            :data="tableData"
            style="width: 100%;"
            border>
            <el-table-column prop="time" :label="$t('Common.time')" />
            <el-table-column prop="storeName" :label="$t('Common.store')" />
            <el-table-column prop="contractNum" :label="$t('Contract.number2')" />
            <el-table-column prop="clientName" :label="$t('Member.member')" />
            <el-table-column prop="clientPhone" :label="$t('Common.telephone_number')" />
            <el-table-column prop="contractType" :label="$t('Contract.type')" />
            <!-- <el-table-column prop="remark" :label="$t('Common.remark')" /> -->
            <el-table-column prop="operationType" :label="$t('Reception.Third.type')" />
            <el-table-column prop="payMethod" :label="$t('Sell.Pay.title')" />
            <el-table-column prop="payableAmt" :label="$t('Charge.amount_receivable')" />
            <el-table-column prop="oweAmt" :label="$t('Member.revenueflow.staymoney')" />
            <el-table-column prop="amt" :label="$t('Member.revenueflow.thisflow')" />
            <el-table-column prop="salesStaffNickname" :label="$t('Member.saler2')" />
            <el-table-column prop="receiverStaffNickname" :label="$t('Member.revenueflow.Cashier')" />
        </el-table>
        <div class="page flex justify-end items-center">
            <el-pagination
                v-if="tableData.length"
                class="text-right mt-8"
                @current-change="fetchData"
                :current-page.sync="pagination.page"
                :page-size="pagination.size"
                layout="total, prev, pager, next, jumper"
                :total="pagination.total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { DatePicker } from 'element-ui';
import filterRole from '@/mixins/filterRole.js';

export default {
    name: 'income-flow',
    components: {
        ElDatePicker: DatePicker,
    },
    mixins: [filterRole],
    data() {
        return {
            form: {
                contractType: null,
                dateFrom: null,
                dateTo: null,
                operationType: null,
                payMethod: null,
                salesStaffId: null,
                storeId: null,
            },
            pagination: {
                size: 20,
                total: 0,
                page: 1,
            },
            tableData: [],
            date: [],
            // 1-会籍合同,2-私教合同,3-租赁柜合同,4-储值卡合同,5-押金合同,6-定金合同
            options: [
                {
                    code: 1,
                    name: this.$t('Stats.Card.member'),
                }, {
                    code: 2,
                    name: this.$t('Member.revenueflow.pri_contract'),
                }, {
                    code: 3,
                    name: this.$t('Stats.Card.locker'),
                }, {
                    code: 4,
                    name: this.$t('Member.revenueflow.valuecard_contract'),
                }, {
                    code: 5,
                    name: this.$t('Member.revenueflow.cash_contract'),
                }, {
                    code: 6,
                    name: this.$t('Sell.title5'),
                },
            ],
            // 1-新办,2-续办,3-转让,4-退款-仅退款,5-退款-客户要求终止合同,6-退款-信息录错重办,7-补卡,8-冻结,9-平账,10-升级,11-定金,12-转店,13-新办押金,14-退还押金
            operations: [
                {
                    code: 1,
                    name: this.$t('Member.revenueflow.new_do'),
                }, {
                    code: 2,
                    name: this.$t('Member.revenueflow.conti_do'),
                }, {
                    code: 3,
                    name: this.$t('Sell.transfer'),
                }, {
                    code: 4,
                    name: this.$t('Member.revenueflow.reimburse'),
                }, {
                    code: 5,
                    name: this.$t('Member.revenueflow.termination'),
                }, {
                    code: 6,
                    name: this.$t('Member.revenueflow.again'),
                }, {
                    code: 7,
                    name: this.$t('Sell.bu_card'),
                }, {
                    code: 8,
                    name: this.$t('Sell.freeze'),
                }, {
                    code: 9,
                    name: this.$t('Member.revenueflow.balancing'),
                }, {
                    code: 10,
                    name: this.$t('Sell.upgrade'),
                }, {
                    code: 11,
                    name: this.$t('Member.revenueflow.earnest'),
                }, {
                    code: 12,
                    name: this.$t('Member.transfer_store'),
                }, {
                    code: 13,
                    name: this.$t('Member.revenueflow.new_cashpledge'),
                }, {
                    code: 14,
                    name: this.$t('Member.revenueflow.return_cashpledge'),
                },
            ],
            // 1-现金,2-刷卡,3-银行转账,4-支付宝(门店),5-微信(门店),6-支付宝,7-微信,8-其他,9-分期支付
            pays: [
                {
                    code: 1,
                    name: this.$t('Sell.Pay.cash'),
                }, {
                    code: 2,
                    name: this.$t('Sell.Pay.swipe'),
                }, {
                    code: 3,
                    name: this.$t('Sell.Pay.bank'),
                }, {
                    code: 4,
                    name: this.$t('Sell.Pay.alipay'),
                }, {
                    code: 5,
                    name: this.$t('Sell.Pay.wechat'),
                }, {
                    code: 8,
                    name: this.$t('Sell.Pay.other'),
                }, {
                    code: 9,
                    name: this.$t('Member.revenueflow.payable_instalments'),
                },
            ],
            staffs: [],
            searchText: null,
            stores: [],
        };
    },
    created() {
        this.fetchData();
        this.fetchStaffs();
        this.fetchStore();
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        handleReset() {
            this.form = {
                contractType: null,
                dateFrom: null,
                dateTo: null,
                operationType: null,
                payMethod: null,
                salesStaffId: null,
                storeId: null,
            };
            this.date = [];
            this.fetchData(1);
        },
        fetchData(page = null) {
            if (page) this.pagination.page = page;

            if (this.date.length) {
                this.form.dateFrom = new Date(this.date[0]).format('YYYY-MM-DD');
                this.form.dateTo = new Date(this.date[1]).format('YYYY-MM-DD');
            } else {
                this.form.dateFrom = null;
                this.form.dateTo = null;
            }
            API.get('statistic/revenue/record/pages', {
                params: {...this.form, ...this.pagination},
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                this.$emit('handleForm', this.form);
            });
        },
        async fetchStaffs() {
            this.staffs = await this.filterRole();
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
    },
};
</script>
<style lang="scss">
.select-item {
    padding: 0 0 15px 0;
    border-bottom: 1px solid rgb(235, 234, 234);
    margin-bottom: 20px;
    .el-select {
        margin-right: 0.5rem;
    }
    .el-button {
        margin-left: 0.5rem;
    }
}
.time-tip {
    font-size: 12px;
    float: right;
    margin-bottom: 15px;
}
.page {
    margin-top: 15px;
}
</style>
